<template>
  <div class='cusAppointment'>
    <img class="title" src="@/assets/serve/cusAppointment/title.png" alt="">
    <img class="bot" src="@/assets/serve/cusAppointment/botImg.png" alt="">
    <div class="text">
			<div class="left">
        <div></div>
				
			</div>
			<div class="right">
				<div class="mb">客服人员稍后将与您联系，请您保持电话畅通。</div>
			</div>
		</div>

		<div class="box">
      <div class="tit-text">在线提前预约，专人省心定制</div>
			<div class="tit-desc">将有专人与您联系，请您保持电话畅通</div>

			<div class="inp1">
				<el-input v-model="form.name" placeholder="姓名"></el-input>
        <el-input v-model="form.phone" maxlength="11" placeholder="手机号码"></el-input>
			</div>

			<div class="inp2">
        <el-cascader
					v-model="form.value"
					:options="cityList"
					placeholder="地址信息"
					popper-class="popperinp2"></el-cascader>


				<el-select v-model="form.requirement" placeholder="定制需求" popper-class="popperinp2">
					<el-option
						v-for="item in options1"
						:key="item.value"
						:label="item.label"
						:value="item.value">
					</el-option>
				</el-select>
			</div>

			<div class="content">
				<el-input
					type="textarea"
					:rows="2"
					placeholder="您的需求（产品、施工...）"
					v-model="form.textarea">
				</el-input>
			</div>

			<div class="btn">
				<el-button @click="toCooperate" type="primary">免费预约</el-button>
			</div>

		</div>
  </div>
</template>

<script>
import '@/util/area'
import axios from 'axios'
const md5 = require('js-md5')
import qs from 'qs'
import Des from '@/util/des.js'
import { doAdvertiseGeneralList } from "@/api/case.js";
import { collectInfo } from "@/api/collectInfo.js";
import { isPhone } from '@/util/utils.js'
export default {
  name: 'cusAppointment',
  components: {
  },
	props: {
    userInfo: {}
  },
  data() {
    return {
			textarea: '',
			form: {
				name: '',
				phone: '',
				value: [],
				requirement: '',
				textarea: ''
			},
			options1: [{
          value: '板材',
          label: '板材'
        }, {
          value: '柜类',
          label: '柜类'
        }, {
          value: '其他可选择',
          label: '其他可选择'
        }],
				cityList: [],
        value1: '',
				value: ''
    }
  },
  computed: { },
  watch: {},
  created() {
		this.getCity()
  },
  mounted() {
  },
  methods: {
	toCooperate() {
		if (!('id' in this.userInfo)) {
			this.$emit('needLogin', true)
			return
		}
		if (!isPhone(this.form.phone)) {
			this.$message('手机号码格式错误')
			return false
		}
		const obj = this.cityList.filter(item => item.value === this.form.value[0])[0]
		const province = obj.label
		const obj1 = obj.children.filter(item => item.value === this.form.value[1])[0]
		let city = obj1.label
		const district = obj1.children.filter(item => item.value === this.form.value[2])[0].label
		const user_id = JSON.parse(localStorage.getItem('giftsUser')).id
		const data = {
			info_type: 1,
			name: this.form.name,
			mobile: this.form.phone,
			province,
			city,
			district,
			address: '',
			requirement: this.form.requirement,
			descr: this.form.textarea,
			user_id
		}
		collectInfo(data).then(res => {
			console.log(res)
			if (res.result == 1) {
				this.form = {
					name: '',
		phone: '',
		value: [],
		requirement: '',
		textarea: ''
				}
				this.$message({message: res.msg, type: 'success'})
			} else {
				this.$message(res.msg)
			}
		})
	},
	getCity() {
      const allCityInformation = city()
      this.cityList = this.traverse(86, allCityInformation)
    },
		traverse(key, obj) {
      const objes = obj[key]
      const arr = []
      for (const i in objes) {
        arr.push({
          label: objes[i],
          value: i,
          children: obj[i] && this.traverse(i, obj)
        })
      }
      return arr
    }
  }
}
</script>
<style lang='less' scoped>
.cusAppointment {
  position: relative;
	max-width: 1920px;
	width: 100%;
	height: 821.5px;
	margin: 0 auto;
	.title{
		position: absolute;
		z-index: 2;
		width: 100%;
		height: 585px;
		top: 0;
		left: 0;
	}
	.bot{
		position: absolute;
		width: 100%;
		height: 828px;
		top: 540.5px;
		left: 0;
	}
	.text{
		font-size: 18px;
		font-family: FZLanTingHeiS-R-GB;
		font-weight: 400;
		color: #4E8B46;
		position: absolute;
		z-index: 3;
		width: 100%;
		top: 659px;
		left: 0;
		padding-left: 185px;
		display: flex;
		text-align: left;
		box-sizing: border-box;
		align-items: center;
		.left{
			display: flex;
			div{
				width: 4px;
				height: 4px;
				background: #4E8B46;
				border-radius: 50%;
				margin-top: 6.5px;
			}
			div:nth-child(1){
				width: 7px;
				height: 7px;
				border: 6.5px solid #ccc;
			}
			div:last-child{
				width: 7px;
				height: 7px;
				border: 6.5px solid #ccc;
			}
		}
		.right{
			margin-left: 17px;
			div{
				padding-top: 6.5px;
			}
			.mb{
				// margin-bottom: 36px;
			}
		}
	}

  .box{
		position: absolute;
		top: 109px;
		right: 362px;
		z-index: 4;
		width: 720px;
		height: 653px;
		background: #FFFFFF;
		border-radius: 25px;
		.tit-text{
			margin-top: 60px;
			font-size: 48px;
			font-family: FZLanTingHeiS-DB-GB;
			font-weight: 400;
			color: #4E8B46;
		}
		.tit-desc{
			margin-top: 36px;
			font-size: 24px;
			font-family: FZLanTingHeiS-R-GB;
			font-weight: 400;
			color: #414141;
		}
		.inp1{
			display: flex;
			justify-content: space-between;
			margin-top: 48px;
			width: 100%;
			box-sizing: border-box;
			padding: 0 50px;
			height: 50px;
			/deep/.el-input{
				width: 295px;
				height: 100%;
				.el-input__inner{
					width: 100%;
					height: 100%;
					border-radius: 25px;
					border: 1px solid #B8D4B4;
					background: #F5F8F4;
					font-size: 24px;
					font-family: FZLanTingHeiS-R-GB;
					&::placeholder {
						font-size: 24px;
						font-family: FZLanTingHeiS-R-GB;
						font-weight: 400;
						color: #ccc;
					}
				}
			}
		}

		.inp2{
			display: flex;
			justify-content: space-between;
			margin-top: 32px;
			width: 100%;
			box-sizing: border-box;
			padding: 0 50px;
			height: 50px;
			/deep/.el-cascader{
				width: 295px;
				height: 100%;
				.el-input{
					width: 100%;
					height: 100%;
					.el-input__inner{
						width: 100%;
						height: 100%;
						border-radius: 25px;
						border: 1px solid #B8D4B4;
						background: #F5F8F4;
						font-size: 24px;
						font-family: FZLanTingHeiS-R-GB;
						&::placeholder {
							font-size: 24px;
							font-family: FZLanTingHeiS-R-GB;
							font-weight: 400;
							color: #ccc;
						}
					}
					.el-input__suffix{
            right: 16px;
					}
					.el-icon-arrow-down {
						position: relative;
						&:before {
							content: '';
							border-top:14px solid #B8D4B4;
							border-left:7px solid transparent;
							border-right:7px solid transparent;
							border-bottom:14px solid transparent;
							position: absolute;
							top: 17.5px;
							left: 25%;
						}
						&.is-reverse {
							transform: rotateZ(-180deg)
						}
					}
				}
			}
			/deep/.el-select{
				width: 295px;
				height: 100%;
				.el-input{
					width: 100%;
					height: 100%;
					.el-input__inner{
						width: 100%;
						height: 100%;
						border-radius: 25px;
						border: 1px solid #B8D4B4;
						background: #F5F8F4;
						font-size: 24px;
						font-family: FZLanTingHeiS-R-GB;
						&::placeholder {
							font-size: 24px;
							font-family: FZLanTingHeiS-R-GB;
							font-weight: 400;
							color: #ccc;
						}
					}
					.el-input__suffix{
            right: 16px;
					}
					.el-icon-arrow-up {
						position: relative;
						&:before {
							content: '';
							border-top:14px solid transparent;
							border-left:7px solid transparent;
							border-right:7px solid transparent;
							border-bottom:14px solid #B8D4B4;
							position: absolute;
							top: 3.5px;
							left: 25%;
						}
					}
				}
			}
		}

    .content{
			position: relative;
			margin: 0 auto;
			margin-top: 32px;
			width: 620px;
			height: 120px;
			/deep/.el-textarea{
				position: absolute;
				top: 0;
				left: 0;
				width: 620px;
				height: 120px;
				font-family: FZLanTingHeiS-R-GB;
				.el-textarea__inner{
					height: 100% !important;
					font-size: 24px;
					font-family: FZLanTingHeiS-R-GB;
					background: #F5F8F4;
					border: 1px solid #B8D4B4;
					border-radius: 25px 25px 25px 25px;
					outline: none;
					resize: none;
					&::placeholder {
						font-size: 24px;
						font-family: FZLanTingHeiS-R-GB;
						font-weight: 400;
						color: #ccc;
					}
				}
			}
		}

		.btn{
			position: relative;
			height: 60px;
			margin-top: 32px;
			button{
				position: absolute;
				width: 620px;
				height: 100%;
				top: 0;
				left: 50px;
			}
			/deep/.el-button--primary{
				background: #4E8B46;
				border-color: #4E8B46;
				border-radius: 25px 25px 25px 25px;
			}
			/deep/.el-button{
				font-size: 32px;
			}
		}
		
	}
}

</style>
<style lang="less">
.popperinp2 {
	margin-top: 5px!important;
	background: #F5F8F4;
	border: 1px solid #B8D4B4;
	border-radius: 25px;
	.el-select-dropdown__item{
    color: #999999;
		font-weight: normal;
		text-align: center;
		height: 47px;
		line-height: 47px;
		font-size: 20px;
		font-family: FZLanTingHeiS-R-GB;
	}
	.selected{
		color: #999999;
		font-weight: normal;
	}
	.el-select-dropdown__item.hover, .el-select-dropdown__item:hover{
    font-size: 24px;
		color: #4E8B46;
		font-weight: 400;
		font-family: FZLanTingHeiS-R-GB;
		background: none;
	}
	.el-cascader-node:not(.is-disabled){
		height: 47px;
		line-height: 47px;
	}
	.el-cascader-menu{
		font-size: 24px;
		font-family: FZLanTingHeiS-R-GB;
		color: #999;
	}
	.el-cascader-node:not(.is-disabled):focus, .el-cascader-node:not(.is-disabled):hover{
		background: none;
	}
	.el-cascader-node.in-active-path, .el-cascader-node.is-active, .el-cascader-node.is-selectable.in-checked-path{
		color: #4E8B46;
		font-weight: 400;
		background: none;
	}
	.popper__arrow {
		display: none;
	}
}
</style>
